(function(){
  'use strict';
  if(window.szcAnimInit) return;
  window.szcAnimInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduced) return;

  /* ── 1. INJECT GLOBAL ANIMATION CSS ── */
  var style = document.createElement('style');
  style.textContent = `
    /* Fade up — default reveal */
    [data-szanim] {
      opacity: 0;
      transform: translateY(32px);
      transition: opacity .9s cubic-bezier(.16,1,.3,1),
                  transform .9s cubic-bezier(.16,1,.3,1);
    }
    [data-szanim].szanim-visible {
      opacity: 1;
      transform: none;
    }
    /* Fade in only */
    [data-szanim="fade"] {
      opacity: 0;
      transform: none;
      transition: opacity 1s ease;
    }
    /* Slide from left */
    [data-szanim="left"] {
      opacity: 0;
      transform: translateX(-40px);
      transition: opacity .9s cubic-bezier(.16,1,.3,1),
                  transform .9s cubic-bezier(.16,1,.3,1);
    }
    /* Slide from right */
    [data-szanim="right"] {
      opacity: 0;
      transform: translateX(40px);
      transition: opacity .9s cubic-bezier(.16,1,.3,1),
                  transform .9s cubic-bezier(.16,1,.3,1);
    }
    /* Scale in */
    [data-szanim="scale"] {
      opacity: 0;
      transform: scale(.92);
      transition: opacity .9s cubic-bezier(.16,1,.3,1),
                  transform .9s cubic-bezier(.16,1,.3,1);
    }
    /* All visible state */
    [data-szanim].szanim-visible {
      opacity: 1 !important;
      transform: none !important;
    }

    /* Stagger children */
    [data-szstagger] > * {
      opacity: 0;
      transform: translateY(28px);
      transition: opacity .8s cubic-bezier(.16,1,.3,1),
                  transform .8s cubic-bezier(.16,1,.3,1);
    }
    [data-szstagger].szanim-visible > * {
      opacity: 1;
      transform: none;
    }

    /* Nav link hover underline */
    .header__menu-item a,
    .header__nav-item a {
      position: relative;
    }
    .header__menu-item a::after,
    .header__nav-item a::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 1px;
      background: #C9A961;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform .35s cubic-bezier(.16,1,.3,1);
    }
    .header__menu-item a:hover::after,
    .header__nav-item a:hover::after {
      transform: scaleX(1);
    }

    /* Product card hover lift */
    .product-card,
    .card,
    .card-wrapper {
      transition: transform .5s cubic-bezier(.16,1,.3,1),
                  box-shadow .5s cubic-bezier(.16,1,.3,1),
                  border-color .5s !important;
    }
    .product-card:hover,
    .card:hover {
      transform: translateY(-8px) !important;
      box-shadow: 0 24px 60px rgba(0,0,0,.4) !important;
    }

    /* Button hover shimmer */
    .button, button[name="add"], .product-form__submit {
      position: relative;
      overflow: hidden;
    }
    .button::before, button[name="add"]::before, .product-form__submit::before {
      content: '';
      position: absolute;
      top: 0; left: -100%;
      width: 60%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(201,169,97,.15), transparent);
      transition: left .6s ease;
      pointer-events: none;
    }
    .button:hover::before, button[name="add"]:hover::before, .product-form__submit:hover::before {
      left: 150%;
    }

    /* Image zoom on hover */
    .product-card img,
    .card__media img,
    .media img {
      transition: transform .8s cubic-bezier(.16,1,.3,1) !important;
    }
    .product-card:hover img,
    .card:hover .card__media img,
    .card:hover .media img {
      transform: scale(1.05) !important;
    }

    /* Footer links */
    .footer a, .footer__link {
      transition: color .3s, letter-spacing .3s !important;
    }
    .footer a:hover, .footer__link:hover {
      letter-spacing: .04em !important;
    }

    /* Scroll progress bar */
    #szc-progress {
      position: fixed;
      top: 0; left: 0;
      height: 2px;
      width: 0%;
      background: linear-gradient(90deg, #C9A961, #EFD9A0);
      z-index: 9999;
      transition: width .1s linear;
      pointer-events: none;
    }

    /* Page transition overlay */
    #szc-overlay {
      position: fixed;
      inset: 0;
      background: #061510;
      z-index: 99999;
      pointer-events: none;
      opacity: 0;
      transition: opacity .5s ease;
    }
    #szc-overlay.active {
      opacity: 1;
      pointer-events: all;
    }

    /* Cursor dot */
    #szc-cursor {
      position: fixed;
      width: 8px;
      height: 8px;
      background: #C9A961;
      border-radius: 50%;
      pointer-events: none;
      z-index: 99998;
      transform: translate(-50%,-50%);
      transition: transform .1s ease, width .3s ease, height .3s ease, opacity .3s ease;
      mix-blend-mode: screen;
    }
    #szc-cursor.expand {
      width: 40px;
      height: 40px;
      opacity: .5;
    }

    /* Header scroll effect */
    .szc-header-scrolled {
      background: rgba(6,21,16,0.99) !important;
      box-shadow: 0 4px 30px rgba(0,0,0,.3) !important;
    }

    /* Smooth image load */
    img {
      transition: opacity .5s ease;
    }
    img.loading {
      opacity: 0;
    }
    img.loaded {
      opacity: 1;
    }
  `;
  document.head.appendChild(style);

  /* ── 2. SCROLL PROGRESS BAR ── */
  var prog = document.createElement('div');
  prog.id = 'szc-progress';
  document.body.appendChild(prog);

  window.addEventListener('scroll', function(){
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    prog.style.width = Math.min(100, pct) + '%';
  }, {passive:true});

  /* ── 3. CUSTOM CURSOR (desktop only) ── */
  if(window.innerWidth > 900){
    var cursor = document.createElement('div');
    cursor.id = 'szc-cursor';
    document.body.appendChild(cursor);

    var cx = 0, cy = 0, tx = 0, ty = 0;
    document.addEventListener('mousemove', function(e){
      tx = e.clientX; ty = e.clientY;
    });

    function animCursor(){
      cx += (tx - cx) * 0.15;
      cy += (ty - cy) * 0.15;
      cursor.style.left = cx + 'px';
      cursor.style.top = cy + 'px';
      requestAnimationFrame(animCursor);
    }
    animCursor();

    document.addEventListener('mouseover', function(e){
      var el = e.target;
      if(el.tagName === 'A' || el.tagName === 'BUTTON' ||
         el.closest('a') || el.closest('button') ||
         el.classList.contains('product-card')){
        cursor.classList.add('expand');
      }
    });
    document.addEventListener('mouseout', function(){
      cursor.classList.remove('expand');
    });
    document.addEventListener('mousedown', function(){
      cursor.style.transform = 'translate(-50%,-50%) scale(.7)';
    });
    document.addEventListener('mouseup', function(){
      cursor.style.transform = 'translate(-50%,-50%) scale(1)';
    });
  }

  /* ── 4. HEADER SCROLL EFFECT ── */
  var header = document.querySelector('.header, header, .site-header, #shopify-section-header');
  if(header){
    var lastScroll = 0;
    window.addEventListener('scroll', function(){
      var s = window.pageYOffset;
      if(s > 80){
        header.classList.add('szc-header-scrolled');
      } else {
        header.classList.remove('szc-header-scrolled');
      }
      lastScroll = s;
    }, {passive:true});
  }

  /* ── 5. INTERSECTION OBSERVER REVEALS ── */
  function addAnimAttrs(){
    /* Headings */
    document.querySelectorAll('h1:not([data-szanim]), h2:not([data-szanim])').forEach(function(el){
      if(!el.closest('#szc-'+ Date.now()) && !el.dataset.szanim){
        el.dataset.szanim = '';
      }
    });
    /* Paragraphs */
    document.querySelectorAll('.product__description p, .rte p').forEach(function(el, i){
      el.dataset.szanim = '';
      el.style.transitionDelay = (i * 0.08) + 's';
    });
    /* Product cards */
    document.querySelectorAll('.product-card, .card-wrapper').forEach(function(el, i){
      if(!el.dataset.szanim){
        el.dataset.szanim = 'scale';
        el.style.transitionDelay = (i % 4 * 0.1) + 's';
      }
    });
    /* Collection grid items */
    document.querySelectorAll('.collection-grid__item, .grid__item').forEach(function(el, i){
      if(!el.dataset.szanim){
        el.dataset.szanim = '';
        el.style.transitionDelay = (i % 4 * 0.1) + 's';
      }
    });
    /* Section headings */
    document.querySelectorAll('.section-header, .title-wrapper').forEach(function(el){
      if(!el.dataset.szstagger) el.dataset.szstagger = '';
    });
    /* Price */
    document.querySelectorAll('.price, .price__regular').forEach(function(el){
      if(!el.dataset.szanim) el.dataset.szanim = 'fade';
    });
    /* Media / images */
    document.querySelectorAll('.media, .product__media-wrapper').forEach(function(el){
      if(!el.dataset.szanim) el.dataset.szanim = 'scale';
    });
    /* Breadcrumbs */
    document.querySelectorAll('.breadcrumb, nav[aria-label]').forEach(function(el){
      if(!el.dataset.szanim) el.dataset.szanim = 'fade';
    });
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var el = e.target;

      if(el.dataset.szstagger !== undefined){
        el.classList.add('szanim-visible');
        Array.from(el.children).forEach(function(child, i){
          setTimeout(function(){
            child.style.opacity = '1';
            child.style.transform = 'none';
          }, i * 100);
        });
      } else {
        el.classList.add('szanim-visible');
      }
      io.unobserve(el);
    });
  }, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});

  function observeAll(){
    document.querySelectorAll('[data-szanim], [data-szstagger]').forEach(function(el){
      io.observe(el);
    });
  }

  /* ── 6. PAGE TRANSITION ── */
  var overlay = document.createElement('div');
  overlay.id = 'szc-overlay';
  document.body.appendChild(overlay);

  // Fade in on load
  overlay.classList.add('active');
  window.addEventListener('load', function(){
    setTimeout(function(){
      overlay.style.opacity = '0';
      setTimeout(function(){
        overlay.style.display = 'none';
      }, 500);
    }, 100);
  });

  // Fade out on link click
  document.addEventListener('click', function(e){
    var link = e.target.closest('a');
    if(!link) return;
    var href = link.getAttribute('href');
    if(!href || href.startsWith('#') || href.startsWith('mailto') ||
       href.startsWith('tel') || href.startsWith('javascript') ||
       link.target === '_blank' || e.metaKey || e.ctrlKey) return;
    if(href.indexOf(window.location.hostname) === -1 && href.startsWith('http')) return;
    e.preventDefault();
    overlay.style.display = 'block';
    requestAnimationFrame(function(){
      overlay.style.opacity = '1';
      setTimeout(function(){
        window.location.href = href;
      }, 450);
    });
  });

  /* ── 7. IMAGE LAZY LOAD FADE ── */
  document.querySelectorAll('img[loading="lazy"]').forEach(function(img){
    if(!img.complete){
      img.classList.add('loading');
      img.addEventListener('load', function(){
        img.classList.remove('loading');
        img.classList.add('loaded');
      });
    }
  });

  /* ── 8. SMOOTH ANCHOR SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if(target){
        e.preventDefault();
        target.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });

  /* ── 9. COUNTER ANIMATION (for stats sections) ── */
  var countIo = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var el = e.target;
      var target = parseInt(el.dataset.szcCount || el.textContent);
      if(isNaN(target) || target > 9999) return;
      var start = null;
      function step(ts){
        if(!start) start = ts;
        var p = Math.min((ts - start) / 1800, 1);
        var ease = p < .5 ? 2*p*p : -1+(4-2*p)*p;
        el.textContent = Math.round(ease * target);
        if(p < 1) requestAnimationFrame(step);
        else el.textContent = target;
      }
      requestAnimationFrame(step);
      countIo.unobserve(el);
    });
  }, {threshold: .5});

  /* ── INIT ── */
  function init(){
    addAnimAttrs();
    observeAll();

    /* Observe stat numbers */
    document.querySelectorAll('.szos-num-big, .szp-stat-num, [data-count]').forEach(function(el){
      countIo.observe(el);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section changes */
  document.addEventListener('shopify:section:load', function(){
    setTimeout(init, 100);
  });

})();

